import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { configs } from '../../../assets/Config';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import ToastPage from '../../includes/ToastPage';
import '../../../assets/styles/RM.css'
import DInventoryAnalyticsPage from './DInventoryAnalyticsPage';
import UpdateInventoryPage from './DUpdateInventoryPage';
import { useCMContext } from '../../../services/contexts/companyManagement/CMContext';
import DInventoryReportsPage from './DInventoryReportsPage';

export default function DIMMainPage() {

    const { setCurrModule, allowedFunc, token } = useLogin()
    const { setProcessedData, showReport } = useCMContext();

    const history = useHistory()

    useEffect(() => {
        (async () => {
            try {
                if (allowedFunc.includes(configs.functionList['depository_parser:depository_parser'])) {
                    setCurrModule(configs.modules.depository)
                    setProcessedData([])
                } else {
                    return history.goBack()
                }
            } catch (error) {

            }
        })()
    }, [])

    // role management main ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id='rmContainer' className="rm-container">
                    {showReport ? <DInventoryReportsPage /> : <DInventoryAnalyticsPage />}
                    {allowedFunc.includes(configs.functionList['depository_parser:depository_parser']) ?
                        <UpdateInventoryPage />
                        : null}
                    <ToastPage />
                </div>
            </div>
        </>
    )
}